import { useEffect, useState } from "react";
import moment from "moment";
import PunctualCourseRepository, { TeachrCourseSessionInfo } from "../../../Repositories/PunctualCourseRepository";
import { monthRange } from "./planningRules";

/**
 * Séances déjà prévues du prof sur un mois (tous élèves confondus), pour
 * signaler les chevauchements en direct dans le calendrier et sur les cartes.
 * Une erreur réseau ne bloque pas la saisie : le serveur fait le contrôle
 * définitif à l'envoi (même filet que sessionConflicts.fetchExternalOverlap).
 */
export const useMonthSessions = (teachrId: number | undefined, month: moment.Moment, clientId?: number | null) => {
    const [sessions, setSessions] = useState<TeachrCourseSessionInfo[]>([]);
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);
    const monthKey = month.format("YYYY-MM");

    useEffect(() => {
        if (!teachrId) return undefined;
        let cancelled = false;
        setLoading(true);
        setFailed(false);
        const { from, to } = monthRange(moment(monthKey, "YYYY-MM"));
        PunctualCourseRepository.getTeachrCourseSessions(teachrId, from, to, undefined, clientId ?? undefined)
            .then((response) => {
                if (!cancelled) setSessions(Array.isArray(response?.sessions) ? response.sessions : []);
            })
            .catch(() => {
                if (!cancelled) {
                    setSessions([]);
                    setFailed(true);
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [teachrId, monthKey, clientId]);

    return { sessions, loading, failed };
};

export default useMonthSessions;
